import { useGetAccountSubAccountListOnlyForA4RoleQuery } from "../../reactQueries/commonRQHooks";

/** as of now this Hook is used for A2 and A4 role only - A2 included later */
export const useGetAccountAndSubAccListOnlyForA4Role = ({ userId }) => {

    const {
        isError: isErrorOnAccSubAccListForA4Role,
        isFetching: isFetchingOnAccSubAccListForA4Role,
        isSuccess: isSuccessOnAccSubAccListForA4Role,
        data: accSubAccList,
        error: errorOnAccSubAccListForA4Role,
    } = useGetAccountSubAccountListOnlyForA4RoleQuery({ userId: userId || "" });

    const clientAccList = accSubAccList?.ClientAccounts || []
    let clientAccountIdListForA4Role = [];

    if (!!isSuccessOnAccSubAccListForA4Role && !!clientAccList) {

        clientAccList.forEach((item) => {
            clientAccountIdListForA4Role.push(item?.Id)
        })
    }

    const clientSubAccList = accSubAccList?.ClientSubAccounts || []
    let clientSubAccountIdListForA4Role = [];

    if (!!isSuccessOnAccSubAccListForA4Role && !!clientSubAccList) {

        clientSubAccList.forEach((item) => {
            clientSubAccountIdListForA4Role.push(item?.Id)
        })
    }

    return {
        clientAccountIdListForA4Role,
        clientSubAccountIdListForA4Role,
        clientAccListForA4Role: clientAccList,
        clientSubAccListForA4Role: clientSubAccList
    }
}